import { Component, Input } from '@angular/core';

@Component({
  selector: 'mable-how-it-works',
  templateUrl: './how-it-works.component.html',
  styleUrls: ['./how-it-works.component.scss'],
})
export class HowItWorksComponent {
  @Input() items: { icon: string; label: string }[] = [];

  /**
   * Prefix for mobile md mode. A work around for icons passed by backend.
   * Prefix will be removed after migrating to ionic 5.
   */
  @Input() iconPrefix = '';
}
